// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* --app-height: 100dvh; */

    /* --menu-width: 450px; */
}

body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    overflow: hidden;

    /* background-color: rgba(2, 8, 32, 1); */

    /* background: linear-gradient(90deg, rgba(32, 2, 5, 1) 0%, rgba(2, 8, 32, 1) 2%); */
    background-color: var(--color-black);
    color: var(--color-white);
    font-family: var(--font1), serif;

    /* font-size: 16px; */
    letter-spacing: 1px;
}

input {
    color: var(--color-white);
    font-family: var(--font1), serif;

    /* font-size: 16px; */
    letter-spacing: 1px;
}

body {
    user-select: none; /* Firefox */ /* Internet Explorer/Edge */
    -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
    overscroll-behavior: contain;
}

main {
    /* height: var(--app-height); */

    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    /* background-color: #b2b2b2; */

    /* background-color: rgb(91, 126, 63); */

    /* background: radial-gradient(circle, rgba(2,0,36,1) 20%, rgba(4,14,54,1) 50%, rgba(2,8,32,1) 80%); */
}

* {
    flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/index.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;;IAE1B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;;IAEhB,yCAAyC;;IAEzC,oFAAoF;IACpF,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;;IAEhC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;;IAEhC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB,EAAE,YAAY,EAAE,2BAA2B;IAC5D,4CAA4C;IAC5C,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;;IAE/B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;;IAEX,+BAA+B;;IAE/B,wCAAwC;;IAExC,sGAAsG;AAC1G;;AAEA;IACI,cAAc;AAClB","sourcesContent":[":root {\n    /* --app-height: 100dvh; */\n\n    /* --menu-width: 450px; */\n}\n\nbody {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    overflow: hidden;\n\n    /* background-color: rgba(2, 8, 32, 1); */\n\n    /* background: linear-gradient(90deg, rgba(32, 2, 5, 1) 0%, rgba(2, 8, 32, 1) 2%); */\n    background-color: var(--color-black);\n    color: var(--color-white);\n    font-family: var(--font1), serif;\n\n    /* font-size: 16px; */\n    letter-spacing: 1px;\n}\n\ninput {\n    color: var(--color-white);\n    font-family: var(--font1), serif;\n\n    /* font-size: 16px; */\n    letter-spacing: 1px;\n}\n\nbody {\n    user-select: none; /* Firefox */ /* Internet Explorer/Edge */\n    -webkit-tap-highlight-color: rgb(0 0 0 / 0%);\n    overscroll-behavior: contain;\n}\n\nmain {\n    /* height: var(--app-height); */\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n\n    /* background-color: #b2b2b2; */\n\n    /* background-color: rgb(91, 126, 63); */\n\n    /* background: radial-gradient(circle, rgba(2,0,36,1) 20%, rgba(4,14,54,1) 50%, rgba(2,8,32,1) 80%); */\n}\n\n* {\n    flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
